import { useEffect, useRef, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Home, Search, Plus, Store, MessageSquare } from "lucide-react";
import { useRealtime } from "../lib/realtime";

const Item = ({ to, icon: Icon, label, badge, testid }) => (
  <NavLink to={to} end={to === "/"} className={({ isActive }) => `relative flex flex-col items-center gap-0.5 text-[10px] flex-1 py-2 transition-colors ${isActive ? "text-[#F5E08F]" : "text-gray-400"}`} data-testid={testid}>
    <span className="relative"><Icon className="w-5 h-5" />{badge > 0 && <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center" data-testid={`${testid}-badge`}>{badge > 99 ? "99+" : badge}</span>}</span>
    {label}
  </NavLink>
);

export default function BottomNav() {
  const { counts } = useRealtime();
  const [hidden, setHidden] = useState(false);
  const last = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      if (y < 10) setHidden(false);
      else if (Math.abs(y - last.current) > 6) setHidden(y > last.current);
      last.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-black/90 backdrop-blur-xl border-t gold-line pb-[env(safe-area-inset-bottom)]"
      style={{ transform: hidden ? "translateY(100%)" : "translateY(0)", transition: "transform 0.3s ease-in-out" }} data-testid="bottom-nav" data-hidden={hidden}>
      <div className="flex items-end h-16 px-2">
        <Item to="/" icon={Home} label="Home" testid="bnav-home" />
        <Item to="/cars" icon={Search} label="Search" testid="bnav-search" />
        <div className="flex-1 flex justify-center">
          <Link to="/sell" className="-mt-7 w-14 h-14 rounded-full flex items-center justify-center shadow-[0_6px_24px_rgba(212,175,55,0.45)] border-4 border-[#08090C] active:scale-95 transition-transform" style={{ background: "var(--gold-grad)" }} aria-label="Sell your car" data-testid="bnav-sell">
            <Plus className="w-7 h-7 text-black" strokeWidth={2.6} />
          </Link>
        </div>
        <Item to="/dealers" icon={Store} label="Dealers" testid="bnav-dealers" />
        <Item to="/chat" icon={MessageSquare} label="Chat" badge={counts.chats} testid="bnav-chat" />
      </div>
    </nav>
  );
}
